import { Bike, Phone, ExternalLink } from "lucide-react";
import { BRAND, DELIVERY_LINKS } from "../data/restaurant";
import { Reveal } from "./motion/Reveal";
import { BrushUnderline } from "./BrushHeading";

export default function DeliveryPartners() {
  return (
    <section id="delivery" data-testid="delivery-section" className="px-4 py-10 sm:px-6 sm:py-16">
      <div className="grain relative mx-auto max-w-6xl overflow-hidden rounded-[2.5rem] border-4 border-jet bg-chestnut px-6 py-14 shadow-hard sm:px-12">
        <div aria-hidden="true" className="pointer-events-none absolute -right-16 -top-16 h-64 w-64 rounded-full bg-ochre/20 blur-3xl" />
        <div className="relative">
          <Reveal className="text-center">
            <h2 className="font-display text-3xl font-black uppercase leading-[1.05] tracking-tight text-cream sm:text-5xl">
              Craving at your door? <BrushUnderline>We deliver.</BrushUnderline>
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-base font-medium text-cream/80">
              Order PATTISTA through our delivery partners — prices on their apps slightly vary.
              In-person pickup deals are available when you call.
            </p>
          </Reveal>

          <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2">
            {DELIVERY_LINKS.map((p, i) => (
              <Reveal key={p.name} delay={i * 0.08}>
                <a
                  href={p.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={p.testid}
                  className="group flex h-full items-center justify-between gap-4 rounded-3xl border-[3px] border-cream/25 bg-cream/5 p-6 transition-all duration-200 hover:-translate-y-1.5 hover:border-cream/60 hover:bg-cream/10"
                >
                  <div className="flex items-center gap-4">
                    <span className="inline-flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl border-[3px] border-jet bg-amber text-jet shadow-hard-sm transition-transform duration-200 group-hover:-rotate-6 group-hover:scale-105">
                      <Bike className="h-7 w-7" aria-hidden="true" />
                    </span>
                    <div>
                      <h3 className="font-display text-xl font-black uppercase text-cream">{p.name}</h3>
                      <p className="text-sm font-bold text-sunshine">Order delivery</p>
                    </div>
                  </div>
                  <span className="inline-flex shrink-0 items-center gap-1.5 rounded-full border-2 border-sunshine/60 px-3 py-1 text-[11px] font-extrabold uppercase tracking-widest text-sunshine">
                    Order online
                    <ExternalLink className="h-3.5 w-3.5" aria-hidden="true" />
                  </span>
                </a>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.15} className="mt-9 flex justify-center">
            <a
              href={BRAND.phoneHref}
              data-testid="delivery-call-cta"
              className="inline-flex items-center gap-2 rounded-full border-[3px] border-cream bg-crimson px-8 py-4 font-display text-base font-extrabold uppercase text-cream shadow-[6px_6px_0_0_#FFB923] transition-all duration-200 hover:-translate-y-1 hover:shadow-[10px_10px_0_0_#FFB923]"
            >
              <Phone className="h-5 w-5" aria-hidden="true" />
              Call for Takeout · {BRAND.phoneDisplay}
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
